import CommentsAndFilesSection from '../utils/CommentsAndFilesSection';

export default class ExtranetOrdersShow {
  constructor() {
    this.handleHistoryClick = this.handleHistoryClick.bind(this);
    this.bindEvents();
    this.sections = new CommentsAndFilesSection();
  }

  bindEvents() {
    $(document).on('click', '[data-view-history]', this.handleHistoryClick);
  }

  handleHistoryClick(event) {
    event.preventDefault();
    const orderId = $(event.currentTarget).data('view-history');
    if (!orderId) return;
    this.openProductHistoryModal(orderId);
  }

  openProductHistoryModal(orderId) {
    const config = $('#product-history-config');
    if (!config.length) return;

    const baseUrl = config.data('url') || config.data('product-history-url');
    if (!baseUrl) return;

    const serviceNumber = config.data('service-number') || 'N/A';
    const url = baseUrl.replace(':id', orderId);

    $('#productHistoryModal').modal('show');
    $('#modal-service-number').text(`Historique des changements - ${serviceNumber}`);
    $('#product-history-content').html(`
      <div class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Chargement...</span>
        </div>
        <p class="mt-2">Chargement de l'historique...</p>
      </div>
    `);

    $.ajax({
      url: url,
      method: 'GET',
      success: (response) => {
        $('#product-history-content').html(response);
      },
      error: (xhr) => {
        let errorMessage = "Erreur lors du chargement de l'historique";
        try {
          const error = JSON.parse(xhr.responseText);
          errorMessage = error.error || errorMessage;
        } catch (e) {}

        $('#product-history-content').html(`
          <div class="alert alert-danger">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            ${errorMessage}
          </div>
        `);
      }
    });
  }

  onDataChanged(data) {
  }

  onDestroy() {
    if (this.sections && typeof this.sections.onDestroy === 'function') {
      this.sections.onDestroy();
    }
    $(document).off('click', '[data-view-history]', this.handleHistoryClick);
  }
}